import React from "react";

// Standard page intro: icon tile + title + optional subtitle on the left,
// page-level actions on the right. Wraps below the title on narrow widths.
const PageHeader = ({ title, subtitle, icon, actions, children, className = "" }) => (
  <div className={`ex-page-header ${className}`.trim()}>
    <div className="ex-page-header-main">
      {icon && (
        <span className="ex-page-header-icon" aria-hidden="true">
          <i className={`pi ${icon}`} />
        </span>
      )}
      <div className="ex-page-header-text">
        <h2 className="ex-page-header-title">{title}</h2>
        {subtitle && <div className="ex-page-header-subtitle">{subtitle}</div>}
      </div>
    </div>
    {(actions || children) && <div className="ex-page-header-actions">{actions}{children}</div>}
  </div>
);

export default PageHeader;
